import { addFileToStore } from 'Services/WeaverUtils'

export handleUpdatingStore = (log) ->
  uploadedToMinio = log.find((item) -> item.includes('Uploaded file to minio'))
  if uploadedToMinio
    id = uploadedToMinio.split('Uploaded file to minio ')[1]
    allFiles = await Weaver.File.list()
    file = allFiles.find(({ _id }) -> _id is id)
    addFileToStore(file)
